export const MIN_DATE = '1900-01-01';

export const isValidDate = (dateToCheck: string | null): boolean => {
    // Split on '-' or '/'
    const splitDate = dateToCheck ? dateToCheck.split(/[-/]/) : null;
    const dateLengths = dateToCheck?.includes('-') ? [4, 2, 2] : [2, 2, 4];
    if (
        !dateToCheck ||
        !splitDate ||
        splitDate.length !== 3 ||
        splitDate.some((d) => d.toLowerCase().trim() === 'undefined')
    )
        return false;
    for (let i = 0; i < splitDate.length; i++) {
        if (splitDate[i].length !== dateLengths[i]) return false;
    }
    if (!dateToCheck) return false;
    const date = new Date(dateToCheck).getTime();
    const minDate = new Date(MIN_DATE).getTime();
    return !isNaN(date) && date > minDate;
};

export const isValidBirthday = (dateToCheck: string | null): boolean => {
    if (!dateToCheck || !isValidDate(dateToCheck)) return false;
    const date = new Date(dateToCheck).getTime();
    const today = new Date();
    const tomorrow = new Date(today.setDate(today.getDate() + 1)).setHours(0, 0, 0, 0);
    return date < tomorrow;
};

export function formatDate(
    dateStr: number | string | Date | null | undefined,
    option: 'short' | 'long' | 'input' = 'short'
) {
    let date: Date;
    if (typeof dateStr === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
        // If the date string matches the pattern dd/mm/yyyy, convert to yyyy-mm-dd
        const [month, day, year] = dateStr.split('/');
        const formatted = `${year}-${month}-${day}`;
        date = new Date(`${formatted}T12:00:00`);
    } else if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        // If the date string matches the pattern yyyy-mm-dd, assume it is noon local time
        date = new Date(`${dateStr}T12:00:00`);
    } else {
        date = new Date(dateStr || '');
    }
    if (isNaN(date.getTime())) return 'Invalid date';
    const options: Intl.DateTimeFormatOptions =
        !option || option !== 'long'
            ? {
                  month: '2-digit',
                  day: '2-digit',
                  year: 'numeric',
              }
            : { year: 'numeric', month: 'long', day: 'numeric' };
    let formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    if (option === 'input') {
        const [month, day, year] = formattedDate.split('/');
        const newFormat = [year, month, day];
        formattedDate = newFormat.join('-');
    }
    return formattedDate;
}

export const isOver65Years = (dateToCheck: string | null): boolean => {
    if (!dateToCheck || !isValidDate(dateToCheck)) return false;
    const date = new Date(dateToCheck).getTime();
    const today = new Date();
    const sixtyFiveYearsAgo = new Date(today.setFullYear(today.getFullYear() - 65)).getTime();
    return date <= sixtyFiveYearsAgo;
};

export const isUnder26Years = (dateToCheck: string | null): boolean => {
    if (!dateToCheck || !isValidDate(dateToCheck)) return false;
    const date = new Date(dateToCheck).getTime();
    const today = new Date();
    const twentySixYearsAgo = new Date(today.setFullYear(today.getFullYear() - 26)).getTime();
    return date >= twentySixYearsAgo;
};

export const isUnder18Years = (dateToCheck: string | null): boolean => {
    if (!dateToCheck || !isValidDate(dateToCheck)) return false;
    const date = new Date(dateToCheck).getTime();
    const today = new Date();
    const eighteenYearsAgo = new Date(today.setFullYear(today.getFullYear() - 18)).getTime();
    return date >= eighteenYearsAgo;
};
